import { Component, Host, h, Prop } from '@stencil/core';

@Component({
    tag: 'sew-ws-cta',
    styleUrl: 'sew-ws-cta.scss',
    shadow: true,
})
export class SewWsCta {
    @Prop() headline: string;

    render() {
        return (
            <Host>
                <div class="headline" innerHTML={this.headline}></div>
                <slot></slot>
            </Host>
        );
    }
}
